import axios from "axios";
import { config } from "../utils/conf";
import { requestHeaders } from "../utils/http";

export const DEFAULT_LIMIT = 10;

export const fetchTransactionReportUploadsTotal = (
  customerId,
  filter,
  accessToken,
) => {
  return {
    type: "FETCH_TRANSACTION_REPORT_UPLOADS_TOTAL",
    payload: axios.get(
      `${config.inventoryApiUrl}/v1/transaction-reports-uploads`,
      {
        headers: requestHeaders(accessToken),
        params: {
          filter,
          customerId: customerId,
        },
      },
    ),
  };
};

export const fetchTransactionReportUploadsList = (
  customerId,
  filter,
  accessToken,
  offset = 0,
  limit = DEFAULT_LIMIT,
) => {
  return {
    type: "FETCH_TRANSACTION_REPORT_UPLOADS_LIST",
    payload: axios.get(
      `${config.inventoryApiUrl}/v1/transaction-reports-uploads`,
      {
        headers: requestHeaders(accessToken),
        params: {
          filter,
          customerId: customerId,
          limit: limit,
          offset: offset,
        },
      },
    ),
  };
};
